import React, { useRef, useEffect } from 'react';

const CertificateRenderer = ({ certificateNumber, certificateDate, certificateName, certificateTitle, canvasWidth, canvasHeight, certificateImageSrc, certificateRemarks, certificateSignImage1, certificateSignatoryName1, certificateSignatoryDesig1, certificateSignatoryEntity1, certificateIsSignatory2, certificateSignImage2, certificateSignatoryName2, certificateSignatoryDesig2, certificateSignatoryEntity2, certificateHasSponsor, certificateSponsorName, certificateSponsorLogo  }) => {
    // console.log(certificateImageSrc, certificateRemarks,  certificateIsSignatory2, certificateSignImage2, certificateSignatoryName2, certificateSignatoryDesig2, certificateSignatoryEntity2, certificateHasSponsor, certificateSponsorName, certificateSponsorLogo  )
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        const date = new Date(certificateDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;

        let fontSize = 18;
        const textName = certificateName;
        const textNameWidth = ctx.measureText(textName).width;
        const xCoordinateName = (canvasWidth - textNameWidth) / 2;
        const adjustedXCoordinateName = xCoordinateName - (textNameWidth / 2) + (fontSize / 2);

        fontSize = 18;
        const textExamTitle = certificateTitle;
        const textExamTitleWidth = ctx.measureText(textExamTitle).width;
        const xCoordinateExamTitle = (canvasWidth - textExamTitleWidth) / 2;
        const adjustedXCoordinateExamTitle = xCoordinateExamTitle - (textExamTitleWidth / 2) + (fontSize / 2);

        fontSize = 12;
        const lineHeight = fontSize * 1.5; 
        const maxWidth = canvasWidth - 40; 
        ctx.font = `${fontSize}px Arial`;        
        const certificateRemarksWidth = ctx.measureText(certificateRemarks).width;
        const xCoordinateCertificateRemarks = (canvasWidth - certificateRemarksWidth) / 2;
        const adjustedXCoordinateExamRemarks = xCoordinateCertificateRemarks - (certificateRemarksWidth / 2) + (fontSize / 2);

        fontSize = 10;
        ctx.font = `${fontSize}px Arial`;        
        const certificateSignatoryWidth = ctx.measureText(certificateSignatoryName2).width;
        const xCoordinateCertificateSignatory = (canvasWidth - certificateSignatoryWidth) / 2;
        const adjustedXCoordinateSignatory = xCoordinateCertificateSignatory - (certificateSignatoryWidth / 2) + (fontSize / 2);

        const certificateImage = new Image();
        const signatoryImage2 = new Image();
        const sponsorLogo = new Image();
        certificateImage.onload = function () {
            ctx.drawImage(certificateImage, 0, 0);
            ctx.fillStyle = 'black';
            ctx.font = '12px Arial';
            ctx.fillText(certificateNumber, 480, 35);
            ctx.font = '18px Arial';
            ctx.fillText(certificateName, adjustedXCoordinateName, 260);
            ctx.font = '18px Arial';
            ctx.fillText(certificateTitle, adjustedXCoordinateExamTitle, 290);
            ctx.font = '12px Arial';
            ctx.fillText(certificateRemarks, 165, 340);
            ctx.font = '12px Arial';
            ctx.fillText(formattedDate, 165, 430);
            if(certificateIsSignatory2 === 1) {
                const signatoryImage2 = new Image();
                signatoryImage2.onload = function() {
                    ctx.drawImage(signatoryImage2, adjustedXCoordinateSignatory, 380);
                    ctx.font = '10px Arial';
                    ctx.fillText(certificateSignatoryName2, adjustedXCoordinateSignatory, 450);
                    ctx.font = '10px Arial';
                    ctx.fillText(certificateSignatoryDesig2, adjustedXCoordinateSignatory, 470);
                };

                signatoryImage2.src = `/certificates/${certificateSignImage2}`;
            }
            if(certificateHasSponsor === 1) {
                const sponsorLogo = new Image();
                sponsorLogo.onload = function() {
                    ctx.drawImage(sponsorLogo, 600, 250);
                };
                sponsorLogo.src = `/certificates/${certificateSponsorLogo}`;
            }
        };
        certificateImage.src = `/certificates/${certificateImageSrc}`;

    }, [certificateNumber, certificateDate, certificateName, certificateTitle, canvasWidth, canvasHeight, certificateImageSrc, certificateRemarks, certificateSignImage1, certificateSignatoryName1, certificateSignatoryDesig1, certificateSignatoryEntity1, certificateIsSignatory2, certificateSignImage2, certificateSignatoryName2, certificateSignatoryDesig2, certificateSignatoryEntity2, certificateHasSponsor, certificateSponsorName, certificateSponsorLogo]);

    return (
        <canvas
            ref={canvasRef}
            width={canvasWidth}
            height={canvasHeight}
            style={{
                maxWidth: '100%',
            }}
        ></canvas>
    );
};

export default CertificateRenderer;
